export class UserClaim {
  isPCMAdmin: boolean = false;
  isPCMUser: boolean = false;
  isPCMSuperUser: boolean = false;  
}